import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useUser } from '../context/UserContext';

export default function AdminSidebar({
    show,
    setShow,
    nombre,
    inmobiliaria
  }: {
    show: any;
    setShow: any;
    nombre?: string;
    inmobiliaria?: string;
  }) {
    const { user } = useUser();
    const [showAdminTools, setShowAdminTools] = useState(false);

    // Verificar si el usuario es admin
    const isAdmin = user?.rol === 'ADMIN' || user?.tipo?.includes?.('admin');

    // Verificar si el usuario es asociado
    const isAsociado = user?.rol === 'ASOCIADO' || user?.tipo === 'asociado';

    // Verificar si el usuario tiene permisos de admin de comité
    const isAdminComite = user?.esAdminComite === true;

    // Obtener foto del usuario
    const userPhoto = user?.foto || user?.originalDoc?.foto;

    let location = useLocation()
    let current = location.pathname
  return (
    <div className={`simple-sidebar sm-sidebar ${show ? 'd-block d-md-block' : 'd-none d-md-block'}`} id="filter_search" >
        <div className="search-sidebar_header">
            <h4 className="ssh_heading">Close Filter</h4>
            <button className="w3-bar-item w3-button w3-large" onClick={()=>setShow(!show)} aria-label="Cerrar menú lateral" type="button"><i className="fa-regular fa-circle-xmark fs-5 text-muted-2" aria-hidden="true"></i></button>
        </div>

        <div className="sidebar-widgets">
            <div className="dashboard-navbar">
                <div className="d-user-avater">
                    {userPhoto ? (
                        <img
                            src={userPhoto}
                            className="img-fluid avater"
                            alt={nombre || user?.nombre || 'Usuario'}
                            style={{
                                width: '80px',
                                height: '80px',
                                objectFit: 'cover',
                                borderRadius: '50%',
                                border: '2px solid #ddd'
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle bg-light d-flex align-items-center justify-content-center mx-auto"
                            style={{
                                width: '80px',
                                height: '80px',
                                border: '2px solid #ddd'
                            }}
                        >
                            <i className="fa-solid fa-user fa-3x text-muted"></i>
                        </div>
                    )}
                    <h4>{nombre || user?.nombre || 'Nombre no disponible'}</h4>
                    <span>{inmobiliaria || user?.inmobiliaria_nombre || 'Inmobiliaria no asignada'}</span>
                </div>
                <div className="d-navigation">
                    <ul>
                        <li className={current === "/dashboard" ? "active" : ""}><Link to="/dashboard"><i className="fa-solid fa-gauge"></i>Dashboard</Link></li>
                        <li className={current === "/my-profile" ? "active" : ""}><Link to="/my-profile"><i className="fa-solid fa-address-card"></i>Mi perfil</Link></li>

                        {/* Mi Agencia - Solo para ASOCIADO */}
                        {isAsociado && user?.inmobiliaria_doc_id && (
                            <li className={current === `/edit-inmobiliaria/${user.inmobiliaria_doc_id}` ? "active" : ""}>
                                <Link to={`/edit-inmobiliaria/${user.inmobiliaria_doc_id}`}>
                                    <i className="fa-solid fa-building"></i>Mi Agencia
                                </Link>
                            </li>
                        )}

                        <li className={current === "/my-property" ? "active" : ""}><Link to="/my-property"><i className="fa-solid fa-building-circle-check"></i>Mis propiedades</Link></li>
                        {/* "Mis Proyectos" eliminado — no se gestionan proyectos por asociado/afiliado. */}
                        <li className={current === "/mis-leads" ? "active" : ""}><Link to="/mis-leads"><i className="fa-solid fa-envelope-open-text"></i>Mis Leads</Link></li>
                        <li className={current === "/mis-cursos" ? "active" : ""}><Link to="/mis-cursos"><i className="fa-solid fa-graduation-cap"></i>Mis Cursos</Link></li>

                        {/* Panel de Comité - Solo para usuarios con permisos de admin de comité */}
                        {isAdminComite && (
                            <li className="mt-3">
                                <Link
                                    to="/admin-comite/dashboard"
                                    className="d-flex align-items-center px-3 py-3"
                                    style={{
                                        backgroundColor: '#0c2339',
                                        borderRadius: '8px',
                                        color: 'white',
                                        textDecoration: 'none',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#1a4a7a';
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#0c2339';
                                        e.currentTarget.style.transform = 'scale(1)';
                                    }}
                                >
                                    <i className="fa-solid fa-users-gear me-2"></i>
                                    <span><strong>Panel de Comité</strong></span>
                                    <i className="fa-solid fa-arrow-right ms-auto"></i>
                                </Link>
                            </li>
                        )}

                        {/* Herramientas Administrativas - Solo para ADMIN */}
                        {isAdmin && (
                            <>
                                <li className="mt-3">
                                    <div
                                        onClick={() => setShowAdminTools(!showAdminTools)}
                                        className="d-flex justify-content-between align-items-center px-3 py-2"
                                        style={{ cursor: 'pointer', backgroundColor: '#f8f9fa', borderRadius: '5px' }}
                                    >
                                        <span>
                                            <i className="fa-solid fa-tools me-2"></i>
                                            <strong>Herramientas Admin</strong>
                                        </span>
                                        <i className={`fa-solid fa-chevron-${showAdminTools ? 'up' : 'down'}`}></i>
                                    </div>
                                </li>

                                {showAdminTools && (
                            <>
                                {/* Padrón Oficial */}
                                <li className="ps-3 mt-2">
                                    <small className="text-muted">Padrón de Miembros</small>
                                </li>
                                <li className={current === "/admin-padron-oficial" ? "active ps-4" : "ps-4"}>
                                    <Link to="/admin-padron-oficial">
                                        <i className="fa-solid fa-clipboard-check"></i>Padrón Oficial
                                    </Link>
                                </li>
                                <li className={current === "/admin-lista-oficial" ? "active ps-4" : "ps-4"}>
                                    <Link to="/admin-lista-oficial">
                                        <i className="fa-solid fa-users"></i>Lista Oficial
                                    </Link>
                                </li>

                                {/* Talleres y Capacitación */}
                                <li className="ps-3 mt-2">
                                    <small className="text-muted">🎓 Talleres y Capacitación</small>
                                </li>
                                <li className={current === "/admin-create-taller" ? "active ps-4" : "ps-4"}>
                                    <Link to="/admin-create-taller">
                                        <i className="fa-solid fa-plus-circle"></i>Crear Taller
                                    </Link>
                                </li>
                            </>
                                )}
                            </>
                        )}

                        {/* Centro de Ayuda */}
                        <li className="mt-4">
                            <Link
                                to="/ayuda"
                                className="d-flex align-items-center px-3 py-2"
                                style={{
                                    backgroundColor: '#e3f2fd',
                                    borderRadius: '8px',
                                    color: '#0c2339',
                                    textDecoration: 'none'
                                }}
                            >
                                <i className="fa-solid fa-circle-question me-2 text-primary"></i>
                                <span>Centro de Ayuda</span>
                            </Link>
                        </li>
                    </ul>
                </div>

            </div>
        </div>

    </div>
  )
}